import { createFileRoute } from '@tanstack/react-router';
import { MdSettingsSuggest } from 'react-icons/md';
import { RiPassExpiredLine } from 'react-icons/ri';

import { ErrorLayout } from '@/components/ErrorLayout';

export const Route = createFileRoute('/error/401')({
  component: RouteComponent,
});

export function RouteComponent() {
  return (
    <ErrorLayout
      code="401"
      title="Accès non autorisé"
      description="Il semblerait que vous n’ayez pas les accès requis pour accéder à cette page..."
      hints={[
        {
          id: 'hint-1',
          icon: <MdSettingsSuggest size={20} />,
          text: 'Vérifiez que vous êtes bien connecté avec un compte disposant des droits nécessaires.',
        },
        {
          id: 'hint-2',
          icon: <RiPassExpiredLine size={20} />,
          text: 'Votre session a peut-être expiré. Essayez de vous reconnecter.',
        },
      ]}
      image="/assets/images/error-401.png"
      cta={{ label: "Retour à la page d'accueil", to: '/' }}
    />
  );
}
